import Footer from "../../component/Footer/Footer";
import { Navbar } from "../../component/Navbar/NavBar";
import { ContactContent } from "./Contact.content";

export const ContactPage = () => {
  return (
    <div className="d-flex flex-column vh-100">
      <Navbar fixedTop={false} />
      <ContactContent />
      <Footer />
    </div>
  );
};